import { AbstractControl } from "@angular/forms";

export function PasswordTooShortValidator(control: AbstractControl): { passwordTooShort: boolean} | null {
  const newPassword = control.value;

  if (!newPassword || newPassword.length < 8) {
    return { passwordTooShort: true };
  }

  return null;
}
